import { styled, Typography, TypographyProps } from "@mui/material";

const BaseFieldLabel = styled(Typography)(({ theme }) => ({
  display: "block",
  marginBottom: theme.spacing(1),
  fontWeight: 600,
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  fontSize: "0.7rem",
}));

export const FieldLabel = (props: TypographyProps) => (
  <BaseFieldLabel variant="caption" {...props} />
);
